import React from 'react';
import { Alert, Row, Col } from 'react-bootstrap';
import ContainerDefault from './ContainerDefault';
import Logo from '../logo.png';


import { Spinner, ProgressBar } from 'react-bootstrap'

function ErrorMessage(props) {
    return (
        Object.keys(props.error).map((key) => {
            console.log(props.error[key])
            return [key.toUpperCase(), props.error[key]];
        }).map((m, index) => {
            return <Alert key={index} className="alert-danger alert-dismissible fade show" role="alert" >
                <strong>{m[0]}:</strong> {m[1]}
            </Alert>
        })
    );

}

function SuccessMessage(props) {
    return (

        <Alert key="alertaSuccess" className="alert-success fade show" role="alert" >
            <strong>Concluído!</strong> {props.successMessage.toString()}
        </Alert>

    )

}

function Loading(props) {
    return (
        <ContainerDefault
            title={props.title}
            container={<div className="text-center">
                <Spinner className=" spinner-border text-info" role="status" />
                {/* <ProgressBar now={props.now} label={`${props.now}%`} /> */}
            </div>} />
    );
}


function CabecalhoConceicao() {


    return <>
        <Row >
            <Col className="text-center">
                <h2><strong>BALANÇA RODOVIÁRIA NOSSA SENHORA DA CONCEIÇÃO</strong></h2>
            </Col>
        </Row>
        <Row>
            <Col className="text-center">
                <h6>Povoado Mulungu do Saco, km 2, Zona Rural, Paripiranga-BA.</h6>
            </Col>
        </Row>
        <Row>
            <Col className="text-center">
                <p>Telefones: 79 99966-5564 / 79 99850-4743 / 79 99973-4891</p>
            </Col>
        </Row>
        <hr />


    </>
}

function CabecalhoSaoJose() {


    return <>
        <Row >
            <Col className="text-center">
                <h2><strong>BALANÇA RODOVIÁRIA SÃO JOSÉ</strong></h2>
            </Col>
        </Row>
        <Row>
            <Col className="text-center">
                <h6>Povoado Aloque/Trevo da entrada de Pinhão, Zona Rural, Frei Paulo - SE.</h6>
            </Col>
        </Row>
        <Row>
            <Col className="text-center">
                <p>Telefones: 79 99966-5564 / 79 99850-4743 / 79 99974-0109</p>
            </Col>
        </Row>
        <hr />


    </>
}
function CabecalhoRiachao() {


    return <>
        <Row >
            <Col className="text-center">
                <h2><strong>BALANÇA RODOVIÁRIA RIACHÃO</strong></h2>
            </Col>
        </Row>
        <Row>
            <Col className="text-center">
                <h6>Rodovia SE-179, km 10, Zona Rural, Simão Dias-SE.</h6>
            </Col>
        </Row>
        <Row>
            <Col className="text-center">
                <p>Telefones: 79 99966-5564 / 79 99850-4743</p>
            </Col>
        </Row>
        <hr />


    </>
}


function RodapeImpressao() {


    return <Row className="text-center" style={{marginTop:'3rem'}} >

        <Col >
            <Row >
                <Col className="text-center">
                    <img src={Logo} height="35" width="66" />
                </Col>
            </Row>
            <Row >
                <Col className="text-center">
                    <div style={{ fontSize: 12 }}>
                        <strong >CrowDe Software</strong>
                    </div>

                </Col>
            </Row>
            <Row>
                <Col className="text-center">
                    <div style={{ fontSize: 12 }}>
                        <p>Telefones:
                            <a href="tel:+5579998271029" target="_blank" class="w3-hover-text-green">+55 79 9 9827-1029</a>  /
                            <a href="tel:+5579991475546" target="_blank" class="w3-hover-text-green">+55 79 9 9147-5546</a> /
                            <a href="tel:+5579991187713" target="_blank" class="w3-hover-text-green">+55 79 9 9118-7713</a>
                        </p>
                        <p>E-mail: <a href="mailto:crowdesoftware@gmail.com" target="_blank" class="w3-hover-text-green">crowdesoftware@gmail.com</a></p>
                    </div>
                </Col>
            </Row>
            {/* <hr /> */}


        </Col>
    </Row>
}

function EmptyValues(props) {
    return (<>Não contem dados...</>);
}

export { ErrorMessage, Loading, EmptyValues, SuccessMessage, CabecalhoConceicao, CabecalhoSaoJose, CabecalhoRiachao, RodapeImpressao };

